import axios from 'axios';
import { useEffect, useState } from 'react'
import Box from 'elements/Box';
import { Button, CircularProgress, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { Link } from 'react-router-dom';
import { ProjectConfig } from 'Global';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const HomeIconsList = () => {

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState<any[]>([]);
  const [refreshList, setRefreshList] = useState(0);

  const handleMouseEnter = (event: any) => {
    event.currentTarget.style.cursor = 'pointer';
  };

  const handleMouseLeave = (event: any) => {
    event.currentTarget.style.cursor = 'default';
  };

  const ordenItem = (idSubiendo: number, nuevoOrdenSubiendo: number, idBajando: number, nuevoOrdenBajando: number) => {
    axios.post(ProjectConfig.api_url, null, {
      params: {
        request: 'orden_home_icon',
        idSubiendo: idSubiendo,
        nuevoOrdenSubiendo: nuevoOrdenSubiendo,
        idBajando: idBajando,
        nuevoOrdenBajando: nuevoOrdenBajando,
      }
    })
    .then((response) => {
      console.log(response.data);
    })
    .catch((err) => {
      console.log(err.data);
    });
  };

  const subir = (icon_id: number, orden: number) => {
    const currentIndex = list.findIndex(item => item.icon_id === icon_id);
    
    if (currentIndex > 0) {
      const updatedList = [...list];
      updatedList[currentIndex].orden = list[currentIndex - 1].orden;
      updatedList[currentIndex - 1].orden = orden;
      
      const idSubiendo = updatedList[currentIndex].icon_id;
      const nuevoOrdenSubiendo = updatedList[currentIndex].orden;
      const idBajando = updatedList[currentIndex - 1].icon_id;
      const nuevoOrdenBajando = updatedList[currentIndex - 1].orden;
      
      setList(updatedList);
      updatedList.sort((a, b) => a.orden - b.orden);
      setList(updatedList);
      
      ordenItem(idSubiendo, nuevoOrdenSubiendo, idBajando, nuevoOrdenBajando);
    }
  };
  
  const bajar = (icon_id: number, orden: number) => {
    const currentIndex = list.findIndex(item => item.icon_id === icon_id);
    
    if (currentIndex < list.length - 1) {
      const updatedList = [...list];
      updatedList[currentIndex].orden = list[currentIndex + 1].orden;
      updatedList[currentIndex + 1].orden = orden;
      
      const idBajando = updatedList[currentIndex].icon_id;
      const nuevoOrdenBajando = updatedList[currentIndex].orden;
      const idSubiendo = updatedList[currentIndex + 1].icon_id;
      const nuevoOrdenSubiendo = updatedList[currentIndex + 1].orden;
      
      setList(updatedList);
      updatedList.sort((a, b) => a.orden - b.orden);
      setList(updatedList);
      
      ordenItem(idSubiendo, nuevoOrdenSubiendo, idBajando, nuevoOrdenBajando);
    }
  };

  /*=========================================================
  LOAD LIST            
  =========================================================*/
  useEffect(() => {
    axios.get(ProjectConfig.api_url, {
      params: {
        request: 'home_icons_list',
        full_list: true
      }
    })
      .then((response) => {
        console.log("Home Icons List:", response.data);
        setList(response.data.list)
        setLoading(true)
      })
      .catch((err) => {
        console.log(err.data);
      })
  }, [refreshList])
  /*=========================================================*/

  return (
    <div id='HomeIconsList'>

      <div className='buttons_top'>
        <h2>Diseño - Iconos del Home</h2>
      </div>

      <div id="task_list_container" className="flex_container">
        <Box id='home_icons_list' title="Iconos del Home" subtitle="Lista">
          {!loading && <div id='loader'><CircularProgress /></div>}
          <TableContainer>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell>Módulo</TableCell>
                  <TableCell>Icono</TableCell>
                  <TableCell>Color</TableCell>
                  <TableCell>Acciones</TableCell>
                  <TableCell>Orden</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item, i) => (
                  <TableRow
                    key={i}
                    hover
                    role="checkbox"
                  >
                    <TableCell>{item.module_key}</TableCell>
                    <TableCell>
                      {item.image ? (
                        <img 
                          src={`${ProjectConfig.api_url.replace('/api/', '/')}/files/home_icons/${item.image}`} 
                          alt={item.module_key}
                          style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                        />
                      ) : (
                        <span style={{ color: '#999' }}>Sin imagen</span>
                      )}
                    </TableCell>
                    <TableCell>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {item.bg_color && (
                          <div 
                            style={{ 
                              width: '30px', 
                              height: '30px', 
                              backgroundColor: item.bg_color,
                              border: '1px solid #ccc',
                              borderRadius: '4px'
                            }}
                          />
                        )}
                        <span>{item.bg_color || '-'}</span>
                      </div>
                    </TableCell>
                    <TableCell>
                      <Button 
                        component={Link} 
                        to={`/admin/home-icons/edit/${item.icon_id}`} 
                        variant="contained"
                        size="small"
                      >
                        Editar
                      </Button>
                    </TableCell>
                    <TableCell>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        {i > 0 && (
                          <KeyboardArrowUpIcon
                            onClick={() => subir(item.icon_id, item.orden)}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                          />
                        )}
                        {i < list.length - 1 && (
                          <KeyboardArrowDownIcon
                            onClick={() => bajar(item.icon_id, item.orden)}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                          />
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    </div>
  );
};

export default HomeIconsList;
